import { createSelector } from 'reselect'
import { get, keys, last } from 'lodash'

//
// const getVisibilityFilter = (state, props) =>
//   state.todoLists[props.listId].visibilityFilter
//
// const getTodos = (state, props) =>
//   state.todoLists[props.listId].todos
//
// const getVisibleTodos = createSelector(
//   [ getVisibilityFilter, getTodos ],
//   (visibilityFilter, todos) => {
//     switch (visibilityFilter) {
//       case 'SHOW_COMPLETED':
//         return todos.filter(todo => todo.completed)
//       case 'SHOW_ACTIVE':
//         return todos.filter(todo => !todo.completed)
//       default:
//         return todos
//     }
//   }
// )
//
// export default getVisibleTodos

const getDataByCountryAndIndicator = (state, props) =>
  state.dataByCountry[props.countryCode][props.indicator]

const getDataByIndicator = (state, props) =>
  state.dataByIndicator[props.indicator]

export const getTrendDataByCountryAndIndicator = createSelector(
  [ getDataByCountryAndIndicator ],
  (data) => {
      const years = keys(data).sort()
      return years.map(year => ({ year, v:get(data[year], 'v')}))
    }

)

export const getLatestFromData = (data) => {
    const countries = keys(data)
    return countries.map(country => {
      const years = keys(data[country]).filter(year=>data[country][year] && data[country][year]["v"] !== undefined).sort()
      if(!years.length) { return null}
      const lastYear = last(years)
      return {
        country,
        year: lastYear,
        v : data[country][lastYear]["v"]
      }
    }).filter(datum=>!!datum)
  }

export const getLastDataByIndicator = createSelector(
  [ getDataByIndicator ],
  (data) => getLatestFromData(data)
)



// WEBPACK FOOTER //
// ./src/state/selectors/index.js